import React from 'react'
import CarpayPaymentResult from '../CarpayPaymentFinished.component'
import { useTranslation } from 'react-i18next'
import { DateTime } from 'luxon'
import { Time } from '@components/CarpayOrderCard/CarpayOrderCard.style'

const PaymentSuccessAnonymous = ({ now }: { now: DateTime }) => {
    const { t } = useTranslation()
    const title = t('carpay.paymentFinished.title')

    return (
        <CarpayPaymentResult>
            <CarpayPaymentResult.Icon variant="Authorised" className="wemolo-check-circle" />
            <CarpayPaymentResult.Title variant="Authorised">
                <span data-testid="payment-success">{title}</span>
            </CarpayPaymentResult.Title>
            <div>
                <Time>{now.toFormat('dd.MM.yyyy HH:mm')}</Time>
            </div>
        </CarpayPaymentResult>
    )
}

export default PaymentSuccessAnonymous
